module.exports = __webpack_public_path__ + "static/AL.190207.COH.WEBW.OCBCLogoResized-a227dba5ebe7f25d688f926cb49e8f63.png";